// OverallAccountPdf.js
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const generateOverallAccountPDF = (data = []) => {
  // eslint-disable-next-line
  const doc = new jsPDF();

  // Title centered
  doc.setFontSize(16);
  const title = 'Day Book Report';
  const pageWidth = doc.internal.pageSize.getWidth();
  const textWidth = doc.getTextWidth(title);
  const x = (pageWidth - textWidth) / 2;
  doc.text(title, x, 20);

  // Table headers
  const tableColumn = ['Sr. No.', 'Perticular', 'Credit (Rs.)', 'Debit (Rs.)', 'Balance (Rs.)'];
  const tableRows = [];

  // Totals
  let totalCredit = 0;
  let totalDebit = 0;
  let totalBalance = 0;

  // Populate rows and calculate totals
  data.forEach((item, index) => {
    const credit = parseFloat(item?.cr_amount || 0);
    const debit = parseFloat(item?.dr_amount || 0);
    const balance = parseFloat(item?.balance || 0);

    totalCredit += credit;
    totalDebit += debit;
    totalBalance += balance;

    const rowData = [
      index + 1,
      `${item?.staff_type || ''} - ${item?.staff_name || ''}`,
      credit.toFixed(2),
      debit.toFixed(2),
      balance.toFixed(2),
    ];
    tableRows.push(rowData);
  });

  // Add total row
  tableRows.push([
    { content: 'Total', colSpan: 2, styles: { halign: 'right', fontStyle: 'bold' } },
    { content: totalCredit.toFixed(2), styles: { fontStyle: 'bold' } },
    { content: totalDebit.toFixed(2), styles: { fontStyle: 'bold' } },
    { content: totalBalance.toFixed(2), styles: { fontStyle: 'bold' } },
  ]);

  // Generate table
  autoTable(doc, {
    startY: 30,
    head: [tableColumn],
    body: tableRows,
    theme: 'grid',
    headStyles: { fillColor: [22, 160, 133] },
    styles: {
      fontSize: 10,
      cellPadding: 3,
    },
  });

  doc.save('day_book.pdf');
};

export default generateOverallAccountPDF;
